import { render, staticRenderFns } from "./SaleOrder.vue?vue&type=template&id=07c4fe20"
import script from "./SaleOrder.vue?vue&type=script&lang=js"
export * from "./SaleOrder.vue?vue&type=script&lang=js"
import style0 from "./SaleOrder.vue?vue&type=style&index=0&id=07c4fe20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports